<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title w-100">{{ title }}</div>
    <div class="user-default-values-list container">
      <div class="button-container">
        <div class="button-left"></div>
        <div class="button-right">
          <a class="pr-2" href="#" @click="showImportModal">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Import Survey Taker Data <font-awesome-icon :icon="['fas', 'upload']"/></span>
            </button>
          </a>
          <a href="/api/v1/admin/download-survey-taker-data-import-template" @click.prevent="downloadTemplate()" id="DownloadSurveyTakerDataTemplate">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Download Template <font-awesome-icon :icon="['fa', 'download']"/></span>
            </button>
          </a>
        </div>
      </div>
      <div class="data-container">
        <div class="col-12">
          <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th>User Default Value Id</th>
                <th>User Id</th>
                <th>Survey Id</th>
                <th>Default Values</th>
                <th>Active</th>
                <th>Date Created</th>
                <th>Date Updated</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
    <vue-modal ref="import-survey-taker-data-file" name="import-survey-taker-data-file" :width="368" :height="200">
      <div class="container">
        <div class="form-group form-row p-2">
          <h5 class="font-weight-bold">Import Survey Taker Data</h5>
        </div>
        <div class="form-group form-row p-2">
          {{ returnMessage }}
        </div>
        <div class="form-group form-row">
          <span class="pr-2">Select a file to upload</span>
          <input ref="importSurveyTakerDataUpload" type="file" @change="onFileChange" />
          <span class="pr-2">** Maximum allowed size is 8 MB</span>
        </div>
        <div class="form-group form-row d-flex justify-content-end">
          <button type="submit" class="btn btn-primary float-right ml-2" v-on:click="this.importFile">
            <span>Import File</span>
            <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
          </button>
          <button
            type="button"
            class="btn btn-primary ml-4"
            @click="closeModal">
            Close
          </button>
        </div>
      </div>
    </vue-modal>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import $ from "jquery";
import jQuery from "jquery";
import axios from "axios";
import Vue from "vue";

import moment from "moment";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import authHeader from "../../services/auth-header";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import UserService from "../../services/user.service";
import SurveySummaryService from "../../services/survey.summary.service";

export default { 
  name: "ImportSurveyTakerData",
  mixins: [AdminMixins, DataTableMixins],
  components: {},
  data() {
    return {
      returnMessage: "",
      title: "Import Survey Taker Data",
      table: {
        id: "user-default-values-list-table",
        columns: []
      },
      processingComplete: false
    };
  },
  methods: {
    showImportModal(){
        this.returnMessage = "";
        this.$modal.show('import-survey-taker-data-file');
    },
    async getTableData() {
      this.table.columns = SurveySummaryService.getUserDefaultValuesTableColumnData();
      this.getAllUserDefaultValues();
    },
    async getAllUserDefaultValues() {
      this.$root.processServerRequest("Loading all user default values");
      SurveySummaryService.getAllUserDefaultValues(this.getTableDataCallback, this);
    },
    getDownloadFilename() {
      return "Survey Taker Data Template";
    },
    onFileChange: function() {
      this.importSurveyTakerDataImportFile = this.$refs.importSurveyTakerDataUpload.files[0];
    },
    async importFile() {
      if (typeof this.importSurveyTakerDataImportFile == "undefined" || this.importSurveyTakerDataImportFile == "") {
        return false;
      }
      this.$root.processServerRequest("Importing survey taker data");
      this.setModalLoading(true);

      this.processingComplete = false;
      const timer = setTimeout(() => {
        if (this.processingComplete == false || this.processingComplete == "false") {
          this.processingComplete = true;
          this.$root.setLoading(false);
          this.setModalLoading(false);
          this.closeModal();
          AdminService.displayInfoMessage({ text: "Processing is taking more time. Import status will be sent via email.", duration: -1 });
        }
      }, 60000);
      
      let formData = new FormData();
      formData.append("file", this.importSurveyTakerDataImportFile);
      formData.append("userId", UserService.getUserId());

      let headers = { "Content-Type": "multipart/form-data" };
      $.extend(headers, await authHeader());

      await axios
        .post(this.baseUrl + "/api/v1/survey-summary/import-survey-taker-data", formData, { headers: headers })
        .then(response => this.importFileCallback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("SurveySummaryService.importFile", error, "admin", this);
          this.setModalLoading(false);
        });

      clearTimeout(timer);
    },
    importFileCallback: function(response) {
      // If processing time is less than a 1 minute, screen will be refreshed with imported records. 
      // Else the response will be sent through email from server side.
      if (this.processingComplete == false || this.processingComplete == "false") {
        this.processingComplete = true;
      
        this.$root.processServerResponse();
        this.setModalLoading(false);

        let statusCode = response.data.statusCode;
        if (statusCode == 200) {
          this.returnMessage = response.data.message;
          this.$root.setLoading(false);
          this.setModalLoading(false);
          this.closeModalRefresh();
          AdminService.displaySuccessMessage({ text: response.data.message });
        } else {
          AdminService.displayErrorMessage({ text: response.data.message });
          this.$root.setLoading(false);
          this.setModalLoading(false);
        }
      }
    },
    closeModal: function() {
      if (this.$refs['import-survey-taker-data-file'] != null) {
        this.$refs['import-survey-taker-data-file'].visible = false;
      }
    },
    closeModalRefresh: function() {
      this.closeModal();
      this.$router.go(0);
    },
    async downloadTemplate() {
      this.setupDownloadItem();
      await SurveySummaryService.getDownloadSurveyTakerDataTemplate(this.surveyCode, this.downloadItemCallback, this);
    }
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      this.table.configuration.order = [
        [0, "desc"]
      ];
    }
  },
  props: {},
  mounted() {}
};
</script>
